import isEmpty from "lodash/isEmpty";
import { t } from "@/i18n-js/instance";
import { Badge } from "@circle-react/components/SettingsApp/Workflows/components/Badge";
import { useFetchPaywallPrice } from "@circle-react/components/SettingsApp/Workflows/hooks/useFetchPaywallPrice";
import { Typography } from "@circle-react-uikit/Typography";

interface PaywallPriceFromDetailsProps {
  paywallId: number;
  paywallPriceId: number;
}

export const PaywallPriceFromDetails = ({
  paywallId,
  paywallPriceId,
}: PaywallPriceFromDetailsProps) => {
  const { paywallPrice, isLoading } = useFetchPaywallPrice({
    paywallId: paywallId.toString(),
    priceId: paywallPriceId.toString(),
  });

  if (isLoading) {
    return <Badge isLoading />;
  }

  if (
    !paywallPrice ||
    isEmpty(paywallPrice) ||
    !paywallPrice.paywall_name ||
    !paywallPrice.display_name
  ) {
    return (
      <Typography.LabelSm>
        {t("settings.workflows.view.deleted_paywall_price")}
      </Typography.LabelSm>
    );
  }

  return (
    <Typography.LabelSm>
      {paywallPrice.paywall_name} - {paywallPrice.display_name}
    </Typography.LabelSm>
  );
};
